const state = {
    appId: '',
    appList: []
};
const mutations = {
    'm:app/appId' (state, id) {
        state.appId = id;
    },
    'm:app/appList' (state, list) {
        state.appList = list;
    }
};
const actions = {};
export default {
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/app/index.js